import ExtendLesson from './component'
export default ExtendLesson
